// This file was auto generated (scripts/generate-i18n-countries.js)

export interface I18nCountries {
    locale: string;
    countries: CountryNames;
}

export interface CountryNames {
    [countryCode: string]: string | string[];
}

export async function getI18nCountries(lang: string): Promise<I18nCountries> {
    switch (lang.toLowerCase()) {
        case "af":
            return await import("i18n-iso-countries/langs/af.json");
        case "am":
            return await import("i18n-iso-countries/langs/am.json");
        case "ar":
            return await import("i18n-iso-countries/langs/ar.json");
        case "az":
            return await import("i18n-iso-countries/langs/az.json");
        case "be":
            return await import("i18n-iso-countries/langs/be.json");
        case "bg":
            return await import("i18n-iso-countries/langs/bg.json");
        case "bn":
            return await import("i18n-iso-countries/langs/bn.json");
        case "bs":
            return await import("i18n-iso-countries/langs/bs.json");
        case "ca":
            return await import("i18n-iso-countries/langs/ca.json");
        case "cs":
            return await import("i18n-iso-countries/langs/cs.json");
        case "cy":
            return await import("i18n-iso-countries/langs/cy.json");
        case "da":
            return await import("i18n-iso-countries/langs/da.json");
        case "de":
            return await import("i18n-iso-countries/langs/de.json");
        case "dv":
            return await import("i18n-iso-countries/langs/dv.json");
        case "el":
            return await import("i18n-iso-countries/langs/el.json");
        case "en":
            return await import("i18n-iso-countries/langs/en.json");
        case "es":
            return await import("i18n-iso-countries/langs/es.json");
        case "et":
            return await import("i18n-iso-countries/langs/et.json");
        case "eu":
            return await import("i18n-iso-countries/langs/eu.json");
        case "fa":
            return await import("i18n-iso-countries/langs/fa.json");
        case "fi":
            return await import("i18n-iso-countries/langs/fi.json");
        case "fr":
            return await import("i18n-iso-countries/langs/fr.json");
        case "gl":
            return await import("i18n-iso-countries/langs/gl.json");
        case "ha":
            return await import("i18n-iso-countries/langs/ha.json");
        case "he":
            return await import("i18n-iso-countries/langs/he.json");
        case "hi":
            return await import("i18n-iso-countries/langs/hi.json");
        case "hr":
            return await import("i18n-iso-countries/langs/hr.json");
        case "hu":
            return await import("i18n-iso-countries/langs/hu.json");
        case "hy":
            return await import("i18n-iso-countries/langs/hy.json");
        case "id":
            return await import("i18n-iso-countries/langs/id.json");
        case "is":
            return await import("i18n-iso-countries/langs/is.json");
        case "it":
            return await import("i18n-iso-countries/langs/it.json");
        case "ja":
            return await import("i18n-iso-countries/langs/ja.json");
        case "ka":
            return await import("i18n-iso-countries/langs/ka.json");
        case "kk":
            return await import("i18n-iso-countries/langs/kk.json");
        case "km":
            return await import("i18n-iso-countries/langs/km.json");
        case "ko":
            return await import("i18n-iso-countries/langs/ko.json");
        case "ku":
            return await import("i18n-iso-countries/langs/ku.json");
        case "ky":
            return await import("i18n-iso-countries/langs/ky.json");
        case "lt":
            return await import("i18n-iso-countries/langs/lt.json");
        case "lv":
            return await import("i18n-iso-countries/langs/lv.json");
        case "mk":
            return await import("i18n-iso-countries/langs/mk.json");
        case "ml":
            return await import("i18n-iso-countries/langs/ml.json");
        case "mn":
            return await import("i18n-iso-countries/langs/mn.json");
        case "ms":
            return await import("i18n-iso-countries/langs/ms.json");
        case "nb":
            return await import("i18n-iso-countries/langs/nb.json");
        case "nl":
            return await import("i18n-iso-countries/langs/nl.json");
        case "nn":
            return await import("i18n-iso-countries/langs/nn.json");
        case "no":
            return await import("i18n-iso-countries/langs/no.json");
        case "pl":
            return await import("i18n-iso-countries/langs/pl.json");
        case "ps":
            return await import("i18n-iso-countries/langs/ps.json");
        case "pt":
            return await import("i18n-iso-countries/langs/pt.json");
        case "ro":
            return await import("i18n-iso-countries/langs/ro.json");
        case "ru":
            return await import("i18n-iso-countries/langs/ru.json");
        case "sd":
            return await import("i18n-iso-countries/langs/sd.json");
        case "sk":
            return await import("i18n-iso-countries/langs/sk.json");
        case "sl":
            return await import("i18n-iso-countries/langs/sl.json");
        case "so":
            return await import("i18n-iso-countries/langs/so.json");
        case "sq":
            return await import("i18n-iso-countries/langs/sq.json");
        case "sr":
            return await import("i18n-iso-countries/langs/sr.json");
        case "sv":
            return await import("i18n-iso-countries/langs/sv.json");
        case "sw":
            return await import("i18n-iso-countries/langs/sw.json");
        case "ta":
            return await import("i18n-iso-countries/langs/ta.json");
        case "tg":
            return await import("i18n-iso-countries/langs/tg.json");
        case "th":
            return await import("i18n-iso-countries/langs/th.json");
        case "tr":
            return await import("i18n-iso-countries/langs/tr.json");
        case "tt":
            return await import("i18n-iso-countries/langs/tt.json");
        case "ug":
            return await import("i18n-iso-countries/langs/ug.json");
        case "uk":
            return await import("i18n-iso-countries/langs/uk.json");
        case "ur":
            return await import("i18n-iso-countries/langs/ur.json");
        case "uz":
            return await import("i18n-iso-countries/langs/uz.json");
        case "vi":
            return await import("i18n-iso-countries/langs/vi.json");
        case "zh":
            return await import("i18n-iso-countries/langs/zh.json");
        default:
            return await import("i18n-iso-countries/langs/en.json");
    }
}

export default getI18nCountries;
